/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModalGNREDetails } from "./modal-request-gnre";
import { ModalNCMDetails } from "./modal-request-ncm";
import { ModalNFFDetails } from "./modal-request-nff";
import { ModalSPEDDetails } from "./modal-request.sped";

interface ModalRequestDetailsProps {
  requestData: any;
}

const detailComponents: Record<string, React.FC<{ requestData: any }>> = {
  NCM: ModalNCMDetails,
  NFF: ModalNFFDetails,
  SPED: ModalSPEDDetails,
  GNRE: ModalGNREDetails,
};

export function ModalRequestDetails({ requestData }: ModalRequestDetailsProps) {
  const DetailComponent =
    detailComponents[requestData.type] || (() => <p>Tipo não suportado</p>);

  return <DetailComponent requestData={requestData} />;
}
